module.exports = __webpack_public_path__ + "media/common/images/badges/active/nezdolna_energie-c63fdddf01adc6cf112b9a46384e62b3.svg";